import { useEffect } from "react";

const GoogleAd = ({ adSlot, adFormat, adStyle }) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("AdSense error:", e);
    }
  }, []);

  return (
    <div style={adStyle}  className="flex items-center justify-center w-full m-auto my-4 p-2">
      <ins
        className="adsbygoogle"
        style={{ display: "block", ...adStyle }}
        data-ad-client="ca-pub-3319455318350320"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
      ></ins>
    </div>
  );
};

export default GoogleAd;
